import { styled, Typography } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const StyledLabel = styled(
  Typography,
  shouldNotForwardProps(["disabled"])
)(({ theme, disabled }) => ({
  position: "absolute",
  backgroundColor: theme.palette.radicalRed[900],
  height: "18px",
  width: "23px",
  maxWidth: "23px",
  borderRadius: "9px",
  color: theme.palette.white.main,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: "-6px",
  top: "-7px",
  ...disabled && {
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.grey[300]
  },
  span: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
})), StyledFloatingActionButton = styled(
  "button",
  shouldNotForwardProps(["withChildren"])
)(
  ({ theme, color = "primary", withChildren }) => ({
    backgroundColor: theme.palette.white.main,
    border: "none",
    width: "42px",
    height: "42px",
    ...withChildren && {
      minWidth: "42px",
      width: "max-content",
      gap: "6px",
      padding: "0 18px",
      letterSpacing: "0.7px"
    },
    borderRadius: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    cursor: "pointer",
    boxShadow: theme.boxShadows.floatingActionButton,
    ...color === "primary" && {
      color: theme.palette.white.main,
      backgroundColor: theme.palette.primary[900],
      "&:hover": {
        backgroundColor: theme.palette.primary[800]
      },
      "&:active": {
        backgroundColor: theme.palette.primary[1e3]
      }
    },
    ...color === "secondary" && {
      color: theme.palette.white.main,
      backgroundColor: theme.palette.secondary[900],
      "&:hover": {
        backgroundColor: theme.palette.secondary[800]
      },
      "&:active": {
        backgroundColor: theme.palette.secondary[1e3]
      }
    },
    ...color === "invert" && {
      color: theme.palette.grey[800],
      "&:hover": {
        backgroundColor: theme.palette.grey[100]
      },
      "&:active": {
        backgroundColor: theme.palette.grey[200]
      }
    },
    "&:disabled": {
      pointerEvents: "none",
      backgroundColor: theme.palette.grey[200],
      boxShadow: "none",
      color: theme.palette.grey[400]
    }
  })
);
export {
  StyledFloatingActionButton,
  StyledLabel
};
//# sourceMappingURL=styles.js.map
